import React, {useState, useEffect, createContext} from 'react';

export const DataContext = createContext();
var elementoJSON = [];

const jsonGrado = [
	{idGrado: 1, descripcionGrado: 'Postdoctorado'},
	{idGrado: 2, descripcionGrado: 'Doctorado'},
	{idGrado: 3, descripcionGrado: 'Maestría'},
	{idGrado: 4, descripcionGrado: 'Especialidad'},
	{idGrado: 5, descripcionGrado: 'Licenciatura'},
	{idGrado: 6, descripcionGrado: 'Preparatoria'},
	{idGrado: 9, descripcionGrado: 'Técnica'},
	{idGrado: 7, descripcionGrado: 'Secundaria'},
	{idGrado: 8, descripcionGrado: 'Primaria'},
];

const jsonCircunscripciones = [
	{idEstado: 14, idCircunscripcion: 1, descripcionCircunscripcion: 'Circunscripción 1'},
	{idEstado: 25, idCircunscripcion: 1, descripcionCircunscripcion: 'Circunscripción 1'},
	{idEstado: 18, idCircunscripcion: 1, descripcionCircunscripcion: 'Circunscripción 1'},
	{idEstado: 10, idCircunscripcion: 1, descripcionCircunscripcion: 'Circunscripción 1'},
	{idEstado: 26, idCircunscripcion: 1, descripcionCircunscripcion: 'Circunscripción 1'},
	{idEstado: 8, idCircunscripcion: 1, descripcionCircunscripcion: 'Circunscripción 1'},
	{idEstado: 2, idCircunscripcion: 1, descripcionCircunscripcion: 'Circunscripción 1'},
	{idEstado: 3, idCircunscripcion: 1, descripcionCircunscripcion: 'Circunscripción 1'},

	{idEstado: 24, idCircunscripcion: 2, descripcionCircunscripcion: 'Circunscripción 2'},
	{idEstado: 11, idCircunscripcion: 2, descripcionCircunscripcion: 'Circunscripción 2'},
	{idEstado: 1, idCircunscripcion: 2, descripcionCircunscripcion: 'Circunscripción 2'},
	{idEstado: 28, idCircunscripcion: 2, descripcionCircunscripcion: 'Circunscripción 2'},
	{idEstado: 5, idCircunscripcion: 2, descripcionCircunscripcion: 'Circunscripción 2'},
	{idEstado: 32, idCircunscripcion: 2, descripcionCircunscripcion: 'Circunscripción 2'},
	{idEstado: 19, idCircunscripcion: 2, descripcionCircunscripcion: 'Circunscripción 2'},

	{idEstado: 7, idCircunscripcion: 3, descripcionCircunscripcion: 'Circunscripción 3'},
	{idEstado: 4, idCircunscripcion: 3, descripcionCircunscripcion: 'Circunscripción 3'},
	{idEstado: 31, idCircunscripcion: 3, descripcionCircunscripcion: 'Circunscripción 3'},
	{idEstado: 30, idCircunscripcion: 3, descripcionCircunscripcion: 'Circunscripción 3'},
	{idEstado: 27, idCircunscripcion: 3, descripcionCircunscripcion: 'Circunscripción 3'},
	{idEstado: 23, idCircunscripcion: 3, descripcionCircunscripcion: 'Circunscripción 3'},
	{idEstado: 20, idCircunscripcion: 3, descripcionCircunscripcion: 'Circunscripción 3'},

	{idEstado: 9, idCircunscripcion: 4, descripcionCircunscripcion: 'Circunscripción 4'},
	{idEstado: 21, idCircunscripcion: 4, descripcionCircunscripcion: 'Circunscripción 4'},
	{idEstado: 17, idCircunscripcion: 4, descripcionCircunscripcion: 'Circunscripción 4'},
	{idEstado: 12, idCircunscripcion: 4, descripcionCircunscripcion: 'Circunscripción 4'},
	{idEstado: 29, idCircunscripcion: 4, descripcionCircunscripcion: 'Circunscripción 4'},
	{idEstado: 13, idCircunscripcion: 4, descripcionCircunscripcion: 'Circunscripción 4'},

	{idEstado: 15, idCircunscripcion: 5, descripcionCircunscripcion: 'Circunscripción 5'},
	{idEstado: 6, idCircunscripcion: 5, descripcionCircunscripcion: 'Circunscripción 5'},
	{idEstado: 16, idCircunscripcion: 5, descripcionCircunscripcion: 'Circunscripción 5'},
	{idEstado: 22, idCircunscripcion: 5, descripcionCircunscripcion: 'Circunscripción 5'},
];
/*
const jsonCircunscripciones = [
	{idEstado: 1, idCircunscripcion: 1, descripcionCircunscripcion: 'Circunscripción 1'},
	{idEstado: 10, idCircunscripcion: 1, descripcionCircunscripcion: 'Circunscripción 1'},
	{idEstado: 13, idCircunscripcion: 1, descripcionCircunscripcion: 'Circunscripción 1'},
	{idEstado: 23, idCircunscripcion: 1, descripcionCircunscripcion: 'Circunscripción 1'},
	{idEstado: 20, idCircunscripcion: 1, descripcionCircunscripcion: 'Circunscripción 1'},
	{idEstado: 28, idCircunscripcion: 1, descripcionCircunscripcion: 'Circunscripción 1'},

	/*   { "idEstado": 2, "idCircunscripcion": 1, "descripcionCircunscripcion": "Circunscripción 1" },
           { "idEstado": 3, "idCircunscripcion": 1, "descripcionCircunscripcion": "Circunscripción 1" },
           { "idEstado": 8, "idCircunscripcion": 1, "descripcionCircunscripcion": "Circunscripción 1" },
           { "idEstado": 10, "idCircunscripcion": 1, "descripcionCircunscripcion": "Circunscripción 1" },
           { "idEstado": 14, "idCircunscripcion": 1, "descripcionCircunscripcion": "Circunscripción 1" },
           { "idEstado": 18, "idCircunscripcion": 1, "descripcionCircunscripcion": "Circunscripción 1" },
           { "idEstado": 25, "idCircunscripcion": 1, "descripcionCircunscripcion": "Circunscripción 1" },
           { "idEstado": 26, "idCircunscripcion": 1, "descripcionCircunscripcion": "Circunscripción 1" },
           { "idEstado": 1, "idCircunscripcion": 2, "descripcionCircunscripcion": "Circunscripción 2" },
           { "idEstado": 5, "idCircunscripcion": 2, "descripcionCircunscripcion": "Circunscripción 2" },
           { "idEstado": 11, "idCircunscripcion": 2, "descripcionCircunscripcion": "Circunscripción 2" },
           { "idEstado": 19, "idCircunscripcion": 2, "descripcionCircunscripcion": "Circunscripción 2" },
           { "idEstado": 22, "idCircunscripcion": 2, "descripcionCircunscripcion": "Circunscripción 2" },
           { "idEstado": 24, "idCircunscripcion": 2, "descripcionCircunscripcion": "Circunscripción 2" },
           { "idEstado": 28, "idCircunscripcion": 2, "descripcionCircunscripcion": "Circunscripción 2" },
           { "idEstado": 32, "idCircunscripcion": 2, "descripcionCircunscripcion": "Circunscripción 2" },
           { "idEstado": 4, "idCircunscripcion": 3, "descripcionCircunscripcion": "Circunscripción 3" },
           { "idEstado": 7, "idCircunscripcion": 3, "descripcionCircunscripcion": "Circunscripción 3" },
           { "idEstado": 20, "idCircunscripcion": 3, "descripcionCircunscripcion": "Circunscripción 3" },
           { "idEstado": 23, "idCircunscripcion": 3, "descripcionCircunscripcion": "Circunscripción 3" },
           { "idEstado": 27, "idCircunscripcion": 3, "descripcionCircunscripcion": "Circunscripción 3" },
           { "idEstado": 30, "idCircunscripcion": 3, "descripcionCircunscripcion": "Circunscripción 3" },
           { "idEstado": 31, "idCircunscripcion": 3, "descripcionCircunscripcion": "Circunscripción 3" },
           { "idEstado": 9, "idCircunscripcion": 4, "descripcionCircunscripcion": "Circunscripción 4" },
           { "idEstado": 12, "idCircunscripcion": 4, "descripcionCircunscripcion": "Circunscripción 4" },
           { "idEstado": 17, "idCircunscripcion": 4, "descripcionCircunscripcion": "Circunscripción 4" },
           { "idEstado": 21, "idCircunscripcion": 4, "descripcionCircunscripcion": "Circunscripción 4" },
           { "idEstado": 29, "idCircunscripcion": 4, "descripcionCircunscripcion": "Circunscripción 4" },
           { "idEstado": 6, "idCircunscripcion": 5, "descripcionCircunscripcion": "Circunscripción 5" },
           { "idEstado": 13, "idCircunscripcion": 5, "descripcionCircunscripcion": "Circunscripción 5" },
           { "idEstado": 15, "idCircunscripcion": 5, "descripcionCircunscripcion": "Circunscripción 5" },
           { "idEstado": 16, "idCircunscripcion": 5, "descripcionCircunscripcion": "Circunscripción 5" }
   
];
*/

const estadosJson = [
	{idEstado: 1, nombreEntidad: "AGUASCALIENTES"},
	{idEstado: 2, nombreEntidad: "BAJA CALIFORNIA"},
	{idEstado: 3, nombreEntidad: "BAJA CALIFORNIA SUR"},
	{idEstado: 4, nombreEntidad: "CAMPECHE"},
	{idEstado: 5, nombreEntidad: "COAHUILA"},
	{idEstado: 6, nombreEntidad: "COLIMA"},
	{idEstado: 7, nombreEntidad: "CHIAPAS"},
	{idEstado: 8, nombreEntidad: "CHIHUAHUA"},
	{idEstado: 9, nombreEntidad: "CIUDAD DE MEXICO"},
	{idEstado: 10, nombreEntidad: "DURANGO"},
	{idEstado: 11, nombreEntidad: "GUANAJUATO"},
	{idEstado: 12, nombreEntidad: "GUERRERO"},
	{idEstado: 13, nombreEntidad: "HIDALGO"},
	{idEstado: 14, nombreEntidad: "JALISCO"},
	{idEstado: 15, nombreEntidad: "MEXICO"},
	{idEstado: 16, nombreEntidad: "MICHOACAN"},
	{idEstado: 17, nombreEntidad: "MORELOS"},
	{idEstado: 18, nombreEntidad: "NAYARIT"},
	{idEstado: 19, nombreEntidad: "NUEVO LEON"},
	{idEstado: 20, nombreEntidad: "OAXACA"},
	{idEstado: 21, nombreEntidad: "PUEBLA"},
	{idEstado: 22, nombreEntidad: "QUERETARO"},
	{idEstado: 23, nombreEntidad: "QUINTANA ROO"},
	{idEstado: 24, nombreEntidad: "SAN LUIS POTOSI"},
	{idEstado: 25, nombreEntidad: "SINALOA"},
	{idEstado: 26, nombreEntidad: "SONORA"},
	{idEstado: 27, nombreEntidad: "TABASCO"},
	{idEstado: 28, nombreEntidad: "TAMAULIPAS"},
	{idEstado: 29, nombreEntidad: "TLAXCALA"},
	{idEstado: 30, nombreEntidad: "VERACRUZ"},
	{idEstado: 31, nombreEntidad: "YUCATAN"},
	{idEstado: 32, nombreEntidad: "ZACATECAS"}
]
const jsonRangoEdades = [
	{idRangoEdad: '17-20', descRangoEdad: 'Menor de 21'},//Por registros con 17 años en bd
	{idRangoEdad: '21-29', descRangoEdad: '21 a 29 años'},
	{idRangoEdad: '30-40', descRangoEdad: '30 a 40 años'},
	{idRangoEdad: '41-50', descRangoEdad: '41 a 50 años'},
	{idRangoEdad: '51-60', descRangoEdad: '51 a 60 años'},
	{idRangoEdad: '61', descRangoEdad: 'Mayor de 60'},
];

const jsonGeneros = [
	{label: 'Hombre', value: 'H'},
	{label: 'Mujer', value: 'M'},
	{label: 'No binario', value: 'NB'},
];

export default function DataProvider(props) {
	const {children} = props;
	let idactores = [];
	const [tiposCandidaturas, setTiposCandidaturas] = useState([]);
	const [entidades, setEntidades] = useState([]);
	const [circunscripciones, setCircunscripciones] = useState(jsonCircunscripciones);
	const [gradosAcademicos, setGradosAcademicos] = useState([]);
	const [rangosEdades, setRangosEdades] = useState(jsonRangoEdades);
	const [grado, setGrado] = useState(jsonGrado);
	const [generos, setGeneros] = useState(jsonGeneros);
	const [actoresPoliticos, setActoresPoliticos] = useState([]);
	const [secciones, setSecciones] = useState([]);
	
	const [jsonEtiquetas, setJsonEtiquetas] = useState();
	const [jsonLigasConsulta, setJsonLigasConsulta] = useState();

	const [jsonCargados, setJsonCargados] = useState(false);
	const [entidadesDetalleProceso, setEntidadesDetalleProceso] = useState([]);

	const [municipios, setMunicipios] = useState([]);
	const [regresar, setRegresar] = useState(false);
	//console.log("circuncripción", circunscripciones);
	const [accionesAfirmativas, setAccionesAfirmativas] = useState([]);

	//-------------------------  Ini Codigo luis Rojas ----------------------------
	const [estados, setEstados] = useState(estadosJson);
	const [juecesDistrito, setJuecesDistrito] = useState([]);
	const [magistradoSalaReg, setMagistradoSalaReg] = useState([]);
	const [magistradoSalaSup, setMagistradoSalaSup] = useState([]);
	const [magistradoTribDJ, setMagistradoTribDJ] = useState([]);
	const [magistradoTrib, setMagistradoTrib] = useState([]);
	const [ministroSupremaCorte, setMinistroSupremaCorte] = useState([]);
	const [catPoderesUnion, setCatPoderesUnion] = useState([]);

	const [graficaPorPoderes, setGraficaPorPoderes] = useState([]);
	const [graficaPorCandidatura, setGraficaPorCandidatura] = useState([]);

	//-------------------------  Fin Codigo luis Rojas ----------------------------

	//---------------------- Ini Codigo Leonardo Cabrera ---------------------------

	const [candidatosSupremaCorte, setCandidatosSupremaCorte] = useState([]);
	const [redesSocialesSupremaCorte, setRedesSocialesSupremaCorte] = useState(null);
	const [cursosCandidatosSupremaCorte, setCursosCandidatosSupremaCorte] = useState(null);
	const [hipervinculosSupremaCorte, setHipervinculosSupremaCorte] = useState(null);

	const [candidatosSalaSuperior, setCandidatosSalaSuperior] = useState([]);
	const [redesSocialesSalaSuperior, setRedesSocialesSalaSuperior] = useState(null);
	const [cursosCandidatosSalaSuperior, setCursosCandidatosSalaSuperior] = useState(null);
	const [hipervinculosSalaSuperior, setHipervinculosSalaSuperior] = useState(null);

	const [candidatosTribunalDisciplina, setCandidatosTribunalDisciplina] = useState([]);
	const [redesSocialesTribunalDisciplina, setRedesSocialesTribunalDisciplina] = useState(null);
	const [cursosCandidatosTribunalDisciplina, setCursosCandidatosTribunalDisciplina] = useState(null);
	const [hipervinculosTribunalDisciplina, setHipervinculosTribunalDisciplina] = useState(null);

	const [candidatosSalaRegional, setCandidatosSalaRegional] = useState([]);
	const [redesSocialesSalaRegional, setRedesSocialesSalaRegional] = useState(null);
	const [cursosCandidatosSalaRegional, setCursosCandidatosSalaRegional] = useState(null);
	const [hipervinculosSalaRegional, setHipervinculosSalaRegional] = useState(null);

	const [candidatosCircuito, setCandidatosCircuito] = useState([]);
	const [redesSocialesCircuito, setRedesSocialesCircuito] = useState(null);
	const [cursosCandidatosCircuito, setCursosCandidatosCircuito] = useState(null);
	const [hipervinculosCircuito, setHipervinculosCircuito] = useState(null);

	const [candidatosJueces, setCandidatosJueces] = useState([]);
	const [redesSocialesJueces, setRedesSocialesJueces] = useState(null);
	const [cursosCandidatosJueces, setCursosCandidatosJueces] = useState(null);
	const [hipervinculosJueces, setHipervinculosJueces] = useState(null);

	//---------------------- Fin Codigo Leonardo Cabrera ---------------------------

	useEffect(() => {
	
		let dateCache = localStorage.getItem(`${process.env.REACT_APP_LOCAL_CACHE_DATE}`);
		let jsonEstadosEleccion = localStorage.getItem(`${process.env.REACT_APP_LOCAL_JSON_ESTADOS_ELECCION}`);
		let newDate = new Date().getTime();
		let consumirJson2 = false;
		if (dateCache === null || dateCache === undefined) {
			consumirJson2 = true;
			dateCache = newDate;
			localStorage.setItem(`${process.env.REACT_APP_LOCAL_CACHE_DATE}`, dateCache);
		} else dateCache = parseInt(dateCache);
		let restaFechas = newDate / 86400 / 1000 - dateCache / 86400 / 1000;
		if (restaFechas < 0 || restaFechas > parseInt(`${process.env.REACT_APP_LOCAL_CACHE_EXPIRATION}`)) {
			localStorage.setItem(`${process.env.REACT_APP_LOCAL_CACHE_DATE}`, newDate);
			consumirJson2 = true;
		}
		if (!consumirJson2 && (jsonEstadosEleccion === null || jsonEstadosEleccion === undefined)) {
			consumirJson2 = true;
		} else if (!consumirJson2) {
			try {
				jsonEstadosEleccion = JSON.parse(jsonEstadosEleccion);
			} catch (e) {
				consumirJson2 = true;
			}
		}

		if (consumirJson2) {
			fetch(`${process.env.REACT_APP_API_URL}documentos/json/catalogoEstadosSecciones.json`)
				.then((r) => r.json())
				.then((data) => {
					setSecciones(data.secciones);
					setEntidades(data.estados);
					//localStorage.clear();
					//localStorage.setItem(`${process.env.REACT_APP_LOCAL_JSON_ESTADOS_ELECCION}`, JSON.stringify(data));
				});
		} else {
			setSecciones(jsonEstadosEleccion.secciones);
			setEntidades(jsonEstadosEleccion.estados);
		}

		let consumirJson = true;
		if (consumirJson) {
			fetch(`${process.env.REACT_APP_API_URL}documentos/json/catalogoTiposCandidaturas.json`)
				.then((r) => r.json())
				.then((data) => {
					setTiposCandidaturas(data);
				});
			fetch(`${process.env.REACT_APP_API_URL}documentos/json/catalogoGradoAcademico.json`)
				.then((r) => r.json())
				.then((data) => {
					setGradosAcademicos(data);
				});
				
			fetch(`${process.env.REACT_APP_API_URL}documentos/json/etiquetas.json`)
				.then((r) => r.json())
				.then((data) => {
					setJsonEtiquetas(data);
				});
			fetch(`${process.env.REACT_APP_API_URL}documentos/json/parametros.json`)
				.then((r) => r.json())
				.then((data) => {
					setJsonLigasConsulta(data);
				});

//-------------------------  Ini Codigo luis Rojas ----------------------------
				fetch(`${process.env.REACT_APP_API_URL}documentos/json/juecesDistrito.json`)
					.then((r) => r.json())
					.then((data) => {
						setJuecesDistrito(data);
					});
				fetch(`${process.env.REACT_APP_API_URL}documentos/json/magistraturaSalasRegionales.json`)
					.then((r) => r.json())
					.then((data) => {
						setMagistradoSalaReg(data);
					});

				fetch(`${process.env.REACT_APP_API_URL}documentos/json/magistraturaSalaSuperior.json`)
					.then((r) => r.json())
					.then((data) => {
						setMagistradoSalaSup(data);
					});
				fetch(`${process.env.REACT_APP_API_URL}documentos/json/magistraturaTribunalDJ.json`)
					.then((r) => r.json())
					.then((data) => {
						setMagistradoTribDJ(data);
					});

				fetch(`${process.env.REACT_APP_API_URL}documentos/json/magistraturaTribunales.json`)
					.then((r) => r.json())
					.then((data) => {
						setMagistradoTrib(data);
					});
				fetch(`${process.env.REACT_APP_API_URL}documentos/json/ministrosSupremaCorte.json`)
					.then((r) => r.json())
					.then((data) => {
						setMinistroSupremaCorte(data);
					});

				fetch(`${process.env.REACT_APP_API_URL}documentos/json/catalogoPoderesUnion.json`)
					.then((r) => r.json())
					.then((data) => {
						setCatPoderesUnion(data);
					});
				fetch(`${process.env.REACT_APP_API_URL}documentos/json/graficaPorPoderesUnion.json`)
					.then((r) => r.json())
					.then((data) => {
						setGraficaPorPoderes(data);
					});
				fetch(`${process.env.REACT_APP_API_URL}documentos/json/graficaPorTipoCandidatura.json`)
					.then((r) => r.json())
					.then((data) => {
						setGraficaPorCandidatura(data);
					});
//-------------------------  Fin Codigo luis Rojas ----------------------------
		}
	}, []);

	//-------------------------  Ini Codigo Leonardo Cabrera ----------------------------

	useEffect(() => {
		if (ministroSupremaCorte) {
			setCandidatosSupremaCorte(ministroSupremaCorte.candidatos);
			setRedesSocialesSupremaCorte(ministroSupremaCorte.redesSociales);
			setCursosCandidatosSupremaCorte(ministroSupremaCorte.cursosCandidatos);
			setHipervinculosSupremaCorte(ministroSupremaCorte.hipervinculos);
		}
	}, [ministroSupremaCorte]);

	useEffect(() => {
		if (magistradoSalaSup) {
			setCandidatosSalaSuperior(magistradoSalaSup.candidatos);
			setRedesSocialesSalaSuperior(magistradoSalaSup.redesSociales);
			setCursosCandidatosSalaSuperior(magistradoSalaSup.cursosCandidatos);
			setHipervinculosSalaSuperior(magistradoSalaSup.hipervinculos);
		}
	}, [magistradoSalaSup]);

	useEffect(() => {
		if (magistradoTribDJ) {
			setCandidatosTribunalDisciplina(magistradoTribDJ.candidatos);
			setRedesSocialesTribunalDisciplina(magistradoTribDJ.redesSociales);
			setCursosCandidatosTribunalDisciplina(magistradoTribDJ.cursosCandidatos);
			setHipervinculosTribunalDisciplina(magistradoTribDJ.hipervinculos);
		}
	}, [magistradoTribDJ]);

	useEffect(() => {
		if (magistradoSalaReg) {
			setCandidatosSalaRegional(magistradoSalaReg.candidatos);
			setRedesSocialesSalaRegional(magistradoSalaReg.redesSociales);
			setCursosCandidatosSalaRegional(magistradoSalaReg.cursosCandidatos);
			setHipervinculosSalaRegional(magistradoSalaReg.hipervinculos);
		}
	}, [magistradoSalaReg]);

	useEffect(() => {
		if (magistradoTrib) {
			setCandidatosCircuito(magistradoTrib.candidatos);
			setRedesSocialesCircuito(magistradoTrib.redesSociales);
			setCursosCandidatosCircuito(magistradoTrib.cursosCandidatos);
			setHipervinculosCircuito(magistradoTrib.hipervinculos);
		}
	}, [magistradoTrib]);

	useEffect(() => {
		if (juecesDistrito) {
			setCandidatosJueces(juecesDistrito.candidatos);
			setRedesSocialesJueces(juecesDistrito.redesSociales);
			setCursosCandidatosJueces(juecesDistrito.cursosCandidatos);
			setHipervinculosJueces(juecesDistrito.hipervinculos);
		}
	}, [juecesDistrito]);
	//-------------------------  Fin Codigo Leonardo Cabrera ----------------------------

	//Se le manda la información del usuario a todos los componentes hijos
	return (
		<DataContext.Provider
			value={{
				tiposCandidaturas,
				setTiposCandidaturas,
				entidades,
				setEntidades,
				circunscripciones,
				setCircunscripciones,
				gradosAcademicos,
				setGradosAcademicos,
				rangosEdades,
				setRangosEdades,
				generos,
				setGeneros,
				grado,
				setGrado,
				secciones,
				setSecciones,
				jsonEtiquetas,
				jsonLigasConsulta,
				jsonCargados,
				setJsonCargados,
				municipios,
				setMunicipios,
				regresar,
				setRegresar,
				estados, 
				setEstados,
				juecesDistrito, 
				setJuecesDistrito,
				magistradoSalaReg, 
				setMagistradoSalaReg,
				magistradoSalaSup, 
				setMagistradoSalaSup,
				magistradoTribDJ, 
				setMagistradoTribDJ,
				magistradoTrib, 
				setMagistradoTrib,
				ministroSupremaCorte, 
				setMinistroSupremaCorte,
				catPoderesUnion, 
				setCatPoderesUnion,
				candidatosSupremaCorte,
				setCandidatosSupremaCorte,
				redesSocialesSupremaCorte,
				setRedesSocialesSupremaCorte,
				cursosCandidatosSupremaCorte,
				setCursosCandidatosSupremaCorte,
				hipervinculosSupremaCorte,
				setHipervinculosSupremaCorte,
				candidatosSalaSuperior,
				setCandidatosSalaSuperior,
				redesSocialesSalaSuperior,
				setRedesSocialesSalaSuperior,
				cursosCandidatosSalaSuperior,
				setCursosCandidatosSalaSuperior,
				hipervinculosSalaSuperior,
				setHipervinculosSalaSuperior,
				candidatosTribunalDisciplina,
				setCandidatosTribunalDisciplina,
				redesSocialesTribunalDisciplina,
				setRedesSocialesTribunalDisciplina,
				cursosCandidatosTribunalDisciplina,
				setCursosCandidatosTribunalDisciplina,
				hipervinculosTribunalDisciplina,
				setHipervinculosTribunalDisciplina,
				candidatosSalaRegional,
				setCandidatosSalaRegional,
				redesSocialesSalaRegional,
				setRedesSocialesSalaRegional,
				cursosCandidatosSalaRegional,
				setCursosCandidatosSalaRegional,
				hipervinculosSalaRegional,
				setHipervinculosSalaRegional,
				candidatosCircuito,
				setCandidatosCircuito,
				redesSocialesCircuito,
				setRedesSocialesCircuito,
				cursosCandidatosCircuito,
				setCursosCandidatosCircuito,
				hipervinculosCircuito,
				setHipervinculosCircuito,
				candidatosJueces,
				setCandidatosJueces,
				redesSocialesJueces,
				setRedesSocialesJueces,
				cursosCandidatosJueces,
				setCursosCandidatosJueces,
				hipervinculosJueces,
				setHipervinculosJueces,
				graficaPorPoderes, 
				setGraficaPorPoderes,
				graficaPorCandidatura, 
				setGraficaPorCandidatura
			}}

			//-------------------------  Codigo luis Rojas apartir de estados hasta  setCatPoderesUnion ----------------------------
		>
			{children}
		</DataContext.Provider>
	);
}
